<template>
  <div class="yjh_login">
    <p class="login_title">登录</p>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
      <FormItem prop="accountName" ref="accountName"
                 :error="formObjError.accountName">``
        <Input :maxlength ="20" v-model.trim="formValidate.accountName" placeholder="请输入用户名称"></Input>
      </FormItem>
      <FormItem prop="password" ref="password"
                 :error="formObjError.password">
        <Input :maxlength ="20" v-model.trim="formValidate.password" type="password" placeholder="请输入用户密码"></Input>
      </FormItem>
      <div class="verification-code ">
        <FormItem prop="captcha" ref="captcha"
                  :error="formObjError.captcha">
          <Input :maxlength ="4" v-model.trim="formValidate.captcha" @keyup.enter.native="handleSubmit('formValidate')" placeholder="请输入验证码"></Input>
        </FormItem>
       <div class="verification-img">
         <img :src="imgUrl" alt="" @click="_getCaptcha()">
       </div>
      </div>
      <FormItem>
        <Button type="primary" @click="handleSubmit('formValidate')">登录</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { login, getCaptcha, getMenu } from '@/api/app'
export default {
  data() {
    return {
      formValidate: {
        accountName: '', // 账号名称
        password: '', // 密码
        captcha: '' // 验证码
      },
      formObjError: {
        accountName: '',
        password: '',
        captcha: ''
      },
      ruleValidate: {
        accountName: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      },
      imgUrl: ''
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.formObjError = {
            accountName: '',
            password: '',
            captcha: ''
          }
          login({
            admin_name: this.formValidate.accountName,
            admin_password: this.formValidate.password,
            captcha: this.formValidate.captcha
          }).then(res => {
            if (res.code === 0) {
              var yjhToken = res.result.YJHTOKEN
              // 获取token并本地存储
              localStorage.setItem('token', yjhToken)
              // 登录成功跳转
              this.checkLogin()
            } else {
              const obj = {
                10501: 'accountName', 10502: 'password', 10503: 'captcha'
              }
              this.formObjError[obj[res.code]] = res.msg
              this._getCaptcha()
            }
          })
        }
      })
    },
    _getCaptcha() {
      getCaptcha().then(res => {
        if (res.code === 0) {
          this.imgUrl = res.result.url
        }
      })
    },
    gotoPage(list) {
      let jump = '/emptyRole'
      if (list.length !== 0) {
        jump = list[0].children[0].url
      }
      this.$router.push({ path: jump })
    },
    checkLogin() {
      getMenu().then(res => {
        if (res && res.code === 0) {
          this.gotoPage(res.result.premissions)
        }
      })
    }
  },
  created() {
    this._getCaptcha()
  },
  mounted() {
    this.checkLogin()
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
  .yjh_login {
    padding: 40px 60px 50px 60px;
    width:420px;
    height:404px;
    background:rgba(255,255,255,1);
    box-shadow:0px 5px 7px 0px rgba(144,164,183,0.22);
    .login_title {
      font-size:24px;
      font-weight:400;
      color:rgba(24,129,220,1);
      height: 24px;
      line-height:24px;
      margin-bottom: 30px;
    }
    .ivu-form-item .ivu-input {
      width:300px;
      height:40px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      padding: 13px 10px;
      border:1px solid rgba(210,220,230,1);
      &:focus{
         border:1px solid rgba(24,129,220,1);
         outline:none!important;
         box-shadow: none;
       }
    }
    .ivu-form-item-error{
      .ivu-input {
        border:1px solid rgba(210,220,230,1);
        &:focus{
          border:1px solid rgba(24,129,220,1);
          outline:none!important;
          box-shadow: none;
        }
      }
    }
    .ivu-form-item-error-tip {
      top: 14px;
      padding: 0 0;
      left: auto;
      right: 10px;
      font-size:12px;
      font-weight:400;
      color:rgba(220,24,24,1);
      line-height:12px;
      position: absolute;
    }
    .ivu-form-item {
      margin-bottom: 20px;
    }
    .ivu-btn {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: rgba(24,129,220,.8);
      box-shadow: 0px 2px 4px 0px rgba(17,31,54,0.06),0px 2px 2px 0px rgba(17,31,54,0.07);
      border-radius: 4px;
      margin-top: 40px;
      padding: 0 0;
      &:hover{
         background-color: rgba(24,129,220,1);
      }
      span {
        vertical-align: bottom;
      }
    }
    .verification-code {
      position: relative;
      .verification-img {
        position: absolute;
        top: 10px;
        right: 10px;
        img {
          width: 54px;
          cursor: pointer;
          height: 20px;
        }
      }
      .ivu-form-item-error-tip {
        right: 70px;
      }
    }
  }
</style>
